import React, { useState } from 'react';
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Link } from 'react-router-dom';


export default function SubscriptionIcon({data,SetSuscribers}) {
// console.log(data)
  const [dropdown , setDropdown] = useState(false);


  
  const removeElement = ()=>{
    
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
     

    
    let index =  userDetails['subscription'].findIndex(element => data.id === element.id);


    userDetails['subscription'].splice(index, 1); 
    
    SetSuscribers(userDetails['subscription']);
    localStorage.setItem("userDetails", JSON.stringify(userDetails));
  }

  
  return (

<div className='w-fit m-1 sm:m-2'>


    {/* dropdown */}
  <div id="dropdown" style={{'zIndex':'1'}} class={`  ${dropdown ? 'relative' :'hidden'} text-base list-none  divide-y divide-gray-100 rounded-lg shadow w-32 bg-gray-700`}>
          <ul class="py-2 text-center" aria-labelledby="dropdownButton">
          <li>
              <button onClick={()=>removeElement()} class="block w-full py-2 font-bold  bg-red-400 hover:bg-red-600 text-gray-200 hover:text-white">Unsuscribe</button>
          </li>
       
          </ul>
      </div>

  <div class="w-fit max-w-sm  border  rounded-lg shadow bg-gray-800 border-gray-700">


      <div class="flex justify-end px-4 ">




        {/* dropdown button */}



        <div className='flex justify-center cursor-pointer ' onClick={removeElement}>
          <MdOutlineDeleteOutline className='text-3xl m-3 hover:text-red-500 '/>
        </div>




      </div>


      <div class="flex flex-col items-center pb-1">
          
          <Link to={`/channel/${data.id}`}><img class="w-24 h-24 mb-3 rounded-full shadow-lg" src={data.img} alt="Bonnie image"/></Link>
          <h5 class="mb-1 text-xl font-medium text-white">{data.channelName}</h5>


      </div>
  </div>
</div>

 

  )
}
